import {axiosRequest} from "../api";
import {API_PATH} from "../../constants";

export const AllergyService = {
  getAllergiesList(params){ return axiosRequest('GET', API_PATH.ALLERGY.LIST(params)) },
  getAllergy(data){ return axiosRequest('POST', API_PATH.ALLERGY.INFO, data) },
  addAllergy(data){ return axiosRequest('POST', API_PATH.ALLERGY.ADD, data) },
  deleteAllergy(data){ return axiosRequest('POST', API_PATH.ALLERGY.DELETE, data) },
}